export default __webpack_public_path__ + "static/media/avisoimg.a3cb8ee8.png";